import { useState } from 'react';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import CheckList from '../../CheckList/CheckList';
import styles from './ApplicabilityModal.module.scss';

const initialState = {
	selectedList: [],
	query: '',
};
const HEADING = 'Select Product Category';
const ApplicableProdCategoryModal = (props) => {
	const {
		toggleApplicableProductCategoriesModal,
		show,
		productCategories,
		selectedCategoryList,
	} = props;
	const [state, setState] = useState(cloneDeep(initialState));
	const { selectedList } = state;
	const handleClose = () => {
		setState({
			...state,
			selectedList: [],
			query: '',
		});
		toggleApplicableProductCategoriesModal(false);
	};
	const handleClick = (idx) => {
		if (selectedList.includes(idx)) {
			const newSelectedList = selectedList.filter((id) => {
				return id !== idx;
			});
			setState({
				...state,
				selectedList: newSelectedList,
			});
		} else {
			const newSelectedList = selectedList;
			newSelectedList.push(idx);
			setState({
				...state,
				selectedList: newSelectedList,
			});
		}
	};

	const handleConfirm = () => {
		const ids = [];
		for (let idx = 0; idx < selectedList.length; idx++) {
			ids.push(productCategories[selectedList[idx]]);
		}
		const list = productCategories.filter((obj) => {
			return selectedList.includes(obj.id);
		});
		props.handleConfirm(list, 'applicableCategories');
		toggleApplicableProductCategoriesModal(false);
		setState({
			...state,
			selectedList: [],
		});
	};
	const handleSearchInput = (queryString) => {
		setState({
			...state,
			query: queryString,
		});
	};

	const generateList = () => {
		return productCategories
			.filter((obj) => {
				return (
					!selectedCategoryList.find((selectedStore) => {
						return selectedStore.id === parseInt(obj.id, 10);
					}) &&
					obj.productCategoryName
						.toLowerCase()
						.indexOf(state.query.trim().toLowerCase()) !== -1
				);
			})
			.map((obj) => {
				const name = obj.productCategoryName
					? `${obj.productCategoryName}`
					: '';
				return {
					id: parseInt(obj.id, 10),
					title: name,
				};
			});
	};

	return (
		<BaseModal
			heading={HEADING}
			open={show}
			handleClose={handleClose}
			handleConfirm={handleConfirm}
		>
			<div className={`${styles.root}`}>
				<CheckList
					list={generateList()}
					selectedItems={state.selectedList}
					handleItemSelect={handleClick}
					showSearch
					handleSearchInput={handleSearchInput}
					placeholder='Search Category'
				/>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const productCategories = state.form.PRODUCT_CATEGORY.data.LIST;
	const { data, show } = state.modal.applicable_product_categories;
	return {
		show,
		data,
		productCategories,
	};
};
ApplicableProdCategoryModal.defaultProps = {
	selectedCategoryList: [],
	show: false,
};

const mapDispatchToProps = {
	toggleApplicableProductCategoriesModal:
		modalActions.toggleApplicableProductCategoriesModal,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ApplicableProdCategoryModal);
